import Module from '@sinclair-digital/sbg-storyline-sdk/lib/storyline/Module';
import StoryBulkEdit from './components/StoryBulkEdit';

export default new Module({
    moduleName: 'StoryTable',
    text: 'Story Table',
    route: 'bulkEdit',
    showNav: true,
    module: StoryBulkEdit,
});
